import { StateService } from '@uirouter/angular';
import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { GfTranslateService } from './core.translate.service';
import { UiService } from './core.ui.service';
import { ProjectService } from './project.service';

@Injectable()
export class ReportsDataService {

    constructor(
        private $window: Window,
        private gfTranslateService: GfTranslateService,
        private projectService: ProjectService,
        private uiService: UiService,
        private stateService: StateService
    ) { }

    public getProjectMembers() {
        const unixName = this.stateService.params.unixName,
            params = {
                group: true,
                page_size: 0
            };

        return new Promise(
            (resolve, reject) => {
                this.projectService.members(unixName, params)
                .then(
                    (response) => {
                        resolve(_.get(response, 'items', []));
                    },
                    () => {
                        var msg = this.gfTranslateService.translate(
                            'There was a problem loading project members for {{unixName}}',
                            {unixName: unixName}
                        );
                        this.uiService.message.showWarning(msg, 'Data Error');
                        resolve([]);
                    }
                );
            }
        );
    }

    /**
        * This function is used to check filters selected for the search and build the
        * search filters object
    */
    public applyFilters(filters) {
        return _.reduce(
            filters.main_fields,
            (carry, filter) => {
                if (_.isObject(filter.value)) {
                    if (_.has(filter.value, 'id') && filter.value.id != '') {
                        carry[filter.alias] = filter.value.id;
                    }
                } else {
                    if (filter.value != "") {
                        carry[filter.alias] = filter.value;
                    }
                }
                return carry;
            },
            {}
        );
    }

    public runReport(params, format) {
        var defaults = {
            download: true,
            report: true,
            format: format
        };

        var queryString = _.map(
            Object.assign(defaults, params),
            (val, key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(val);
            }
        ).join('&');

        this.$window.open('/api/report?' + queryString, '_self');
    }

    public setPieChartData(items) {
        var chartItems = _.map(
            items,
            (item) => {
                return {
                    key: _.values(item)[0],
                    y: parseInt(_.values(item)[1])
                };
            }
        );
        return chartItems;
    }
}
